// Single source of truth for chain metadata. Flip REACT_APP_NETWORK_ENV
// to swap testnet <-> mainnet without touching any other code.

export const NETWORK_ENV = (process.env.REACT_APP_NETWORK_ENV || 'testnet').toLowerCase();

const CHAINS = {
  bsc: {
    testnet: {
      chainId: 97,
      name: 'BSC Testnet',
      label: 'BSC',
      explorer: 'https://testnet.bscscan.com',
      defaultRpc: 'https://bsc-testnet-rpc.publicnode.com',
      // Mock USDT we control on BSC testnet, 18 decimals.
      // Override via REACT_APP_USDT_ADDRESS in .env if you redeploy.
      usdt: process.env.REACT_APP_USDT_ADDRESS || '0xd19Ebd702beFD63D49771ddE01eb4a57695b7e61',
    },
    mainnet: {
      chainId: 56,
      name: 'BSC',
      label: 'BSC',
      explorer: 'https://bscscan.com',
      defaultRpc: 'https://bsc-rpc.publicnode.com',
      // Canonical BSC USDT (BEP-20), 18 decimals
      usdt: process.env.REACT_APP_USDT_ADDRESS || '0x55d398326f99059fF775485246999027B3197955',
    },
  },
};

export function chainConfig(chain = 'bsc') {
  const c = CHAINS[chain];
  if (!c) throw new Error(`Unknown chain: ${chain}`);
  return c[NETWORK_ENV] || c.testnet;
}

export function txUrl(chain, txHash) {
  if (!txHash) return null;
  return `${chainConfig(chain).explorer}/tx/${txHash}`;
}

export function addressUrl(chain, address) {
  if (!address) return null;
  return `${chainConfig(chain).explorer}/address/${address}`;
}

export const BSC_CHAIN_ID = chainConfig('bsc').chainId;
export const USDT_ADDRESS = chainConfig('bsc').usdt;
